export const invoiceTypes = {
  carrier: 'carrier',
  donate: 'donate',
  // bound: 'bound'
}

export const payMethods = {
  creditCard: 'creditCard',
  linePay: 'linePay',
  mobilePay: 'mobilePay',  // applePay: 'applePay',  // googlePay: 'googlePay',  // samsungPay: 'samsungPay',
  alipay: 'alipay', //支付寶
}

export const payMethodDetails = {
  creditCard: {
    value: 'creditCard',
    label: '信用卡 / Credit Card',
    isTK: true,
  },
  linePay: {
    value: 'linePay',
    label: 'LINE Pay',
     isTK: false,
  },
  mobilePay: {
    value: 'mobilePay',
    label: '行動支付 / Mobile Pay (Apple/Google/Samsung Pay)',
    isTK: true,
  },
  // alipay: { // barcode?? next feature
  //   value: 'alipay',
  //   label: '支付宝 / Alipay (中國消費者/Mainland China only)',
  // }
}

export const confirmMsgs = {
  confirm: {
    value: 'confirm',
    msg: {
      ch: '付款已完成, 請關閉頁面.',
      en: 'Payment completed, please close the page.'
    }
  },
  cancel: {
    value: 'cancel',
    msg: {
      ch: '付款已取消, 請關閉頁面.',
      en: 'Payment was canceled. Please close the page.'
    }
  },
  failed: {
    value: 'failed',
    msg: {
      ch: '付款失敗, 請關閉頁面.',
      en: 'Payment failed, please close the page.'
    }
  },
  notFound: {
    value: 'notFound',
    msg: {
      ch: '訂單已失效, 請關閉頁面.',
      en: 'Order expired. Please close the page.'
    }
  },
  orderCreateFail: {
    value: 'orderCreateFail',
    msg: {
      ch: '訂單建立失敗, 請關閉頁面.',
      en: 'Order creation failed. Please close the page.'
    }
  },
}


export const modalMsg = {
  cancel: {
    value: 'cancel',
    ch: '確定取消訂單?',
    en: 'Are you sure you want to cancel the order?'
  },
  payment: {
    value: 'payment',
    ch: '送出訂單?',
    en: 'Are you sure you want to submit the order?',
    // payIfCh: '如付款意外中斷, 請重新掃描QR code或重新選擇商品',
    // payIfEn: 'If the payment was unexpectedly interrupted, please scan the QR code again or reselect the product.'
  }
}
